module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/高画素AFカメラ.24ec834d.png";